import { FeaturedContent } from '@chemist4u/newt-components';
import { storeName } from '@lib/config/brand';
import { composeThemeToken } from '@lib/mappers';

const SkeletonCategoryCard = () => (
  <div className="flex w-full items-center nw-gap-tight nw-rounded-card border nw-border-context-soft nw-bg-card nw-pl-tight nw-pr-tight nw-py-tight">
    <div className="size-16 shrink-0 rounded-full bg-gray-100" />
    <div className="h-5 flex-1 rounded bg-gray-100" />
  </div>
);

export default function SkeletonFeaturedCategories() {
  return (
    <div data-theme={composeThemeToken(storeName, 'neutral-default')}>
      <FeaturedContent
        layout="grid"
        itemGridSize="wide"
        contentClassName="animate-pulse"
        heading={{
          tag: 'h2',
          children: 'How can our pharmacists help you today?',
        }}
      >
        {Array.from({ length: 6 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton, index is stable
          <SkeletonCategoryCard key={i} />
        ))}
      </FeaturedContent>
    </div>
  );
}
